import React, { Fragment, useState } from 'react';

//Hooks
import useTracking from '../Hooks/useTracking';

// Libraries
// Import Swiper React components
import SwiperCore, { Navigation, EffectFade, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/effect-fade/effect-fade.scss';

// Components
import CLink from "./cLinks";

// Utils
import { randomString } from "../Utils/md5-hash";


SwiperCore.use([Navigation, EffectFade, Autoplay]);


const CarouselBrands2 = ({ desktop, carousel }) => {

    carousel = carousel.filter(item => item.fieldCommonTrBrand && item.fieldCommonTrBrand.id !== "missing");

    // for(var i = 0; i < 60 ; i++){
    //     carousel.push(carousel[0]);
    // }
    
    /* Creation Colonne */
    let carousel_column = [];
    let newItem = [];

    for (let i = 0; i < carousel.length; i++) {

        newItem.push(carousel[i]);

        if ((i + 1) % 10 === 0) {
            carousel_column.push(newItem);
            newItem = [];
        }
    }

    if (newItem.length > 0) {
        carousel_column.push(newItem);
    }

    // TRACKING - Select content
    const [trackingEvent, setTrackingEvent] = useState({});
    const tracking = useTracking(trackingEvent); // eslint-disable-line

    const selectContent = (contentName, refresh) => {
        setTrackingEvent({
            event: 'select_content',
            args: {
                content_type: "Marque",
                content_name: contentName
            },
            refresh: refresh
        });
    };

    return (
        <>
            {carousel_column.length > 0 &&
                <div className="c-carouselBrands2">

                    <Swiper className="c-carouselBrands2_items"
                        navigation={false}
                        slidesPerView="auto"
                        spaceBetween={desktop ? 24 : 24}
                        watchSlidesVisibility={true}
                        allowTouchMove={((desktop && carousel_column.length > 2) || (!desktop && carousel_column.length > 1)) ? true : false}
                        loop={false}
                        pagination={((desktop && carousel_column.length > 2) || (!desktop && carousel_column.length > 1)) ? { clickable: true } : false}
                    >

                        {
                            carousel_column.map((items, index) => {
                                const slideKey = `slideBrand2_${index}`;

                                return (
                                    <SwiperSlide key={slideKey} className="c-carouselBrands2_item">

                                        {
                                            items.map(({ path, title, drupalInternalNid, fieldBrandImgLogo }, index2) => {
                                                const slideKey2 = `subslideBrand2_${index2}`;

                                                return (
                                                    <>
                                                    <CLink key={"" + slideKey + "_" + slideKey2} className={"c-carouselBrands2_link"} url={path.alias ? path.alias : '/node/' + drupalInternalNid}
                                                        handleClick={() => selectContent(title, randomString(6))}>
                                                        <div className="c-carouselBrands2_visuel">
                                                            {fieldBrandImgLogo && <img
                                                                src={desktop ? fieldBrandImgLogo.links.commonLogoDesktop.href : fieldBrandImgLogo.links.commonLogoMobile.href}
                                                                alt={title} />}
                                                        </div>
                                                    </CLink>
                                                    </>
                                                )
                                            })
                                        }



                                    </SwiperSlide>
                                )
                            })
                        }

                    </Swiper>

                </div>
            }
        </>
    )
};

export default CarouselBrands2;